export default "__VITE_ASSET__B0YDPM9U__"